import React from 'react';
import { useLoginPresenter } from './presenter';
import { LoginView } from './view';

export const LoginPage: React.FC = () => {
  const { state, actions } = useLoginPresenter();
  return (
    <LoginView
      username={state.username}
      password={state.password}
      loading={state.loading}
      error={state.error}
      onUsernameChange={actions.setUsername}
      onPasswordChange={actions.setPassword}
      onSubmit={actions.onSubmit}
    />
  );
};

export default LoginPage;
